import styled from "styled-components"
import doctorImage from "../../../../assets/Mayo/Doctor2.png"

export default function MayoRecommendation() {
  return (
    <Container>
      <Image src={doctorImage}/>
      
      <Title>
        Follow Up Appointments
      </Title>
      <Text>
        Make sure you are all set up for your follow ups - your 30 days and your 1 year appointments.
      </Text>
      
      <Title>
        Our Rehabilitation Program
      </Title>
      <Text>
        To help with your recovery, you are encouraged to attend a cardiac rehabilitation program in your area, 10 days from your discharge day.
      </Text>
    </Container>
  )
}

const Container = styled.div`
  color: #1A1A1A;
  display: flex;
  flex-direction: column;
  align-items: center;
`

const Image = styled.img`
  margin-bottom: 28px;
`

const Title = styled.p`
  margin: 0;
  margin-bottom: 3px;
  
  font-size: 22px;
  font-weight: 600;
  text-align: center;
`

const Text = styled.p`
  margin: 0;
  font-size: 19px;
  margin-bottom: 33px;
  text-align: center;
`